<template>
  <div v-if="showMessage" class="field-message fm-warning">
    {{ showMessage }}
  </div>
</template>

<script>
import { AccountRulesPrefix } from '@/modules/accounts/domain/AccountRulesPrefix';

export default {
  name: 'AccountPrefixValidator',
  props: {
    accountValue: { type: [String, Number], default: '' },
    enabledGroups: {
      type: Array,
      default: function () {
        return ['7', '6', '43', '44', '40', '41']
      }
    }
  },
  computed: {
    showMessage() {
      if (this.enabledGroups == null || (Array.isArray(this.enabledGroups) && this.enabledGroups.length === 0)) return ''
      if (this.accountValue === null || this.accountValue === undefined || this.accountValue === '') return ''
      const rules = new AccountRulesPrefix(this.enabledGroups)
      return rules.getMessage(this.accountValue)
    }
  }
}
</script>

<style scoped lang="scss">
  .field-message {
    display: flex;
    align-items: center;
    gap: 6px;
    margin-top: -18px !important;
    margin-bottom: 15px;
    font-size: 0.95rem;
    line-height: 1.3;
    padding: 4px 8px;
    border-radius: 4px;

    &.fm-warning {
      color: #ff9800;
      background-color: #fff4e5;
    }
  }
</style>
